import { render, staticRenderFns } from "./FenceForm.vue?vue&type=template&id=be282960&"
import script from "./FenceForm.vue?vue&type=script&lang=ts&"
export * from "./FenceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports